module.exports = "<div class=\"spinner-container\" *ngIf=\"showSpinner\">\n  <div class=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/spinner/spinner.component.html
// module id = ./src/app/shared/components/spinner/spinner.component.html
// module chunks = main